import { Box, Card, CardContent, Skeleton } from '@mui/material';
import React from 'react';

const ExerciseCardSkeleton = ({ width }: { width?: string }) => {
  return (
    <Card sx={{ width: width || '100%', mb: 4, maxWidth: '100%' }}>
      <CardContent sx={{ display: 'flex', gap: 2 }}>
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="rounded" height={143} width={133} />
        </Box>
        <Box sx={{ flex: 5, mt: -1 }}>
          <Skeleton width="126px" sx={{ fontSize: '1.75rem' }} />
          <Skeleton width="260px" sx={{ fontSize: '1.25rem' }} />
          <Skeleton width="176px" sx={{ fontSize: '1.25rem', mb: -1 }} />
          <Skeleton width="176px" sx={{ fontSize: '1.25rem' }} />
          <Skeleton width="208px" sx={{ fontSize: '1.25rem' }} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default ExerciseCardSkeleton;
